import React from 'react';

export type BadgeColor = 'neutral' | 'red' | 'yellow' | 'green' | 'blurple';

interface BadgeProps {
  color?: BadgeColor;
  children?: React.ReactNode;
}

export default function Badge({ color = 'blurple', children = 'Badge' }: BadgeProps) {
  const colorStyles: Record<BadgeColor, string> = {
    neutral:
      'bg-neutral-50 text-neutral-600 inset-ring-neutral-500/10 dark:bg-neutral-400/10 dark:text-neutral-400 dark:inset-ring-neutral-400/20',
    red: 'bg-red-50 text-red-600 inset-ring-red-600/10 dark:bg-red-400/10 dark:text-red-400 dark:inset-ring-red-400/20',
    yellow:
      'bg-yellow-50 text-yellow-800 inset-ring-yellow-600/20 dark:bg-yellow-400/10 dark:text-yellow-500 dark:inset-ring-yellow-400/20',
    green:
      'bg-green-50 text-green-700 inset-ring-green-600/20 dark:bg-green-400/10 dark:text-green-400 dark:inset-ring-green-500/20',
    blurple:
      'bg-blurple-50 text-blurple-700 inset-ring-blurple-700/10 dark:bg-blurple-400/10 dark:text-blurple-400 dark:inset-ring-blurple-400/30',
  };

  return (
    <span
      className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium inset-ring ${colorStyles[color]}`}
    >
      {children}
    </span>
  );
}
